// 导入封装好的 axios 实例
import request from '@/utils/request'


//模板列表接口
export function templateList(data) {
    return request({
        url: '/program/equipment/template/page',
        method: 'post',
        data
    })
}


//新增模板接口
export function addtemplate(data) {
    return request({
        url: '/program/equipment/template',
        method: 'post',
        data
    })
}


//删除模板接口
export function delTemplate(id) {
  return request({
    url: `/program/equipment/template/${id}`,
    method: 'delete',
  })
}


//启用模板接口
export function templateOn(id) {
    return request({
        url: `/program/equipment/template/on/${id}`,
        method: 'post'
    })
}

//禁用模板接口
export function templateOff(id) {
    return request({
        url: `/program/equipment/template/off/${id}`,
        method: 'post'
    })
}


//查询设备模板
export function templateSensorList(id) {
    return request({
        url: `/program/equipment/template/${id}`,
        method: 'get',
    })
}
